import React from 'react'

import * as styles from 'common/builder/components/chart/FlowChart/components/Block/generic/SubscribeRequest/SubscribeRequest.styles'
import { BlockComponent } from 'common/builder/components/chart/FlowChart/components/Block/types'
import { Button } from 'common/builder/components/chart/FlowChart/components/Button/Button'
import { InteractiveBlockContainer } from 'common/builder/components/chart/FlowChart/components/InteractiveBlockContainer/InteractiveBlockContainer'
import ImagePreview from 'common/builder/components/chart/FlowChart/nodes/blocks/common/ImagePreview'
import PersonalizedText from 'common/builder/components/chart/FlowChart/nodes/shared/PersonalizedText'
import { FlowChartSubscribeRequestBlock } from 'common/builder/components/chart/FlowChart/types/FlowChartSubscribeRequestBlock'

export const SubscribeRequest: BlockComponent<FlowChartSubscribeRequestBlock> = ({ block }) => {
  const { preview } = block.data

  return (
    <InteractiveBlockContainer id={block.id} style={styles.Wrapper}>
      {preview && (
        <ImagePreview
          url={preview.url}
          style={styles.Image}
          originalSize={preview.size}
          targetWidth={styles.BLOCK_WIDTH}
        />
      )}

      <view style={styles.Content}>
        {Boolean(block.data.label) && <PersonalizedText>{block.data.label}</PersonalizedText>}

        <PersonalizedText style={styles.Title}>{block.data.title}</PersonalizedText>

        <PersonalizedText style={styles.Subtitle}>{block.data.subTitle}</PersonalizedText>
        {block.data.buttons.map((button) => (
          <Button key={button.id} button={button} />
        ))}
      </view>
    </InteractiveBlockContainer>
  )
}
